import { writeToCookie } from "./cookie";

(async (): Promise<void> => {
    const fetchTravelAgency = async (): Promise<void> => {
        const urlParams = new URLSearchParams(window.location.search);
        const travelagency = urlParams.get('travelagency');

        if (travelagency !== null) {
            writeToCookie("travelagency=" + travelagency);
        }
    }
    await fetchTravelAgency()
})()
